import { render, staticRenderFns } from "./LaboratoryOrders.vue?vue&type=template&id=4c737fd0&scoped=true"
import script from "./LaboratoryOrders.vue?vue&type=script&lang=js"
export * from "./LaboratoryOrders.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryOrders.vue?vue&type=style&index=0&id=4c737fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c737fd0",
  null
  
)

export default component.exports